export default __webpack_public_path__ + "static/push-5ff48e6e229c3a3649ca12fe0abb888d.png";